import iposApi from '../../api/iposApi';

export const saveBranchInfo = data => ({
  type: 'SAVE_BRANCH_INFO',
  data,
});

export const loadBranches = () => async (dispatch, getState) => {
  const { currentLanguageId } = getState();
  const url = '/GetAllBranch';
  const params = {
    language_id: currentLanguageId
  };

  try {
    const response = await iposApi.get(url, { params });
    return  response.data;
  } catch (error) {
    return [];
  }
};

export const loadBranchesChainByParentGuidCode = (branchId) => async (dispatch, getState) => {
  const url = '/GetAllBranchChainByParentGuidCode';
  const params = {
    branch_guid_code: branchId
  };

  try {
    const response = await iposApi.get(url, { params });
    return  response.data;
  } catch (error) {
    return [];
  }
};

export const loadBranchInfo = (branchId) => async (dispatch, getState) => {
  const { currentLanguageId } = getState();
  const url = '/GetBranchByCode';
  const params = {
    branchId: branchId,
    language_id: currentLanguageId
  };

  // try {

  // throw "Test";

    const response = await iposApi.get(url, { params });
    const branchInfo = response.data;
    branchInfo.branch_guid_code = branchId;

    // branchInfo.latitude=32.08001224698591;
    // branchInfo.longitude=34.81500825506498;

    dispatch(saveBranchInfo(branchInfo));

    return response.data;

  // } catch (error) {
  //   throw error;
    // dispatch(() => ({ type: 'ERROR', data: error }));
  // }
};
